import request from '@/utils/request'
import { md5 } from '@/utils/jsencrypt'
// import { concat } from 'core-js/core/array'

// 登录方法
export function login(account, pass, code, uuid) {
  const password = md5(pass,32)
  const data = {
    account,
    password,
    code,
    uuid
  }
  return request({
    url: '/auth/login',
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/auth/getInfo',
    method: 'post'
  })
}

// 退出方法
// export function logout() {
//   return request({
//     url: '/auth/logout',
//     method: 'post'
//   })
// }

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/auth/getCode',
    method: 'post'
  })
}